angular.module('product-group', ['core'])
    .factory('ProductGroup', function ($resource) {
        return $resource('/crm/api/product-group/:id', {}, {
            list: {method: 'GET', isArray: true},
            get: {method: 'GET'},
            table: {method: 'GET', isArray: false, url: '/crm/api/product-group/table'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'}
        });
    })
    .service('ProductGroupService', function ($rootScope, toastr, modals, ProductGroup) {
        this.add = () => {
            let entity = {
                active: true,
                id: null
            };
            return editModal(entity);
        };
        this.edit = id => {
            ProductGroup.get({id: id}).$promise.then(entity => editModal(entity));
        }
        this.remove = item => {
            return modals.confirmDelete(item.name, () => ProductGroup.delete({id: item.id}, () => $rootScope.$broadcast('productgroup.updated')).$promise);
        };

        function editModal(entity) {
            return modals.open('app/product-group/edit-modal.html', 'ProductGroupDialogController', entity, {size: 'md'}, "$ctrl");
        }
    })
    .component('productGroupList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/product-group/list.html',
        controller: function ($scope, $state, ProductGroupService) {
            this.reset = () => this.filters = {};
            this.ProductGroupService = ProductGroupService;

            $scope.$on("productgroup.updated", () => $state.reload());
        }
    })
    .controller('ProductGroupDialogController', function ($scope, $rootScope, $uibModalInstance, data, toastr, ProductGroup) {
        this.item = data;

        this.cancel = () => $uibModalInstance.dismiss('Canceled');

        this.save = () => {
            let promise;
            if (this.item.id !== null) {
                promise = ProductGroup.update(this.item).$promise;
            } else {
                promise = ProductGroup.save(this.item).$promise;
            }
            return promise.then(result => {
                $rootScope.$broadcast('productgroup.updated');
                $uibModalInstance.close(result);
                toastr.success("Zapisano");
            })
        };
    })
    .config(function ($stateProvider) {
        $stateProvider.state('productGroupList', {
            parent: 'app',
            url: '/product-group?{page:int}&{size:int}&sort&search',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': "productGroupList"
            },
            resolve: {
                filters: $stateParams => angular.copy($stateParams),
                page: (ProductGroup, $q, $stateParams) => ProductGroup.table(angular.copy($stateParams)).$promise
            }
        });
    });
